<template>
  <v-container>
    <equipment-tab></equipment-tab
    ><v-container>
      <base-material-card
        v-if="equipmentProfile"
        icon="mdi-file-document"
        color="primary"
        inline
        class="px-5 py-3 my-12"
      >
        <template v-slot:after-heading>
          <div class="headline my-4 text-no-wrap font-weight-bold">
            {{ $t("dashboard.equipmentDocs") }}
          </div>
        </template>

        <upload-datasheet
          name="datasheet"
          :data="equipmentProfile.datasheet"
          @done="setDatasheet"
          :uid="equipmentProfile.id"
          @delete="removeDatasheet"
        />

        <upload-datasheet
          name="drawings"
          :data="equipmentProfile.drawings"
          @done="setDrawings"
          :uid="equipmentProfile.id"
          @delete="removeDrawings"
        />

        <upload-media :uid="equipmentProfile.id" @done="updateMediaList" />

        <v-divider class="my-12" />
        <v-row justify="center" align="center">
          <media-element
            v-for="(item, index) in media"
            :key="index"
            :item="item"
            :index="index"
            @delete="deleteElement"
            @remove="media.splice(index, 1)"
          />
        </v-row>
      </base-material-card> </v-container
  ></v-container>
</template>

<script>
import { mapState } from "vuex";
import { storage } from "@/plugins/db";

export default {
  components: {
    "upload-datasheet": () => import("./UploadDatasheet"),
    "upload-media": () => import("./UploadMedia"),
    "media-element": () => import("./MediaElement")
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"]),
    media() {
      return this.equipmentProfile?.media || [];
    }
  },
  data() {
    return {
      activeTab: "",
      tabs: [
        {
          name: "EquipmentProfile/Dashboard",
          text: this.$t("dashboard.dashboard")
        },
        { name: "EquipmentProfile/Ranges", text: this.$t("dashboard.ranges") },
        {
          name: "EquipmentProfile/OperationalValues",
          text: this.$t("dashboard.operationalValues")
        },
        {
          name: "EquipmentProfile/Charts",
          text: this.$t("dashboard.graphics")
        },
        {
          name: "EquipmentProfile/ReliabilityList",
          text: this.$t("dashboard.reliability")
        },
        {
          name: "EquipmentProfile/RepairLog",
          text: this.$t("dashboard.repairLog")
        },
        {
          name: "EquipmentProfile/Documents",
          text: this.$t("dashboard.documents")
        }
      ]
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square",
      text: ""
    });
    try {
      await this.$store.dispatch(
        "equipments/bindAnEquipment",
        this.$route.params.id
      );
      await this.$store.dispatch("events/bindEvents", this.$route.params.id);
      loading.close();
    } catch (error) {
      this.$dialog.notify.error(error, {
        position: "top-right",
        timeout: 5000
      });
    }
  },
  methods: {
    calculateVersionTag(list) {
      const tagList = list.map(elem => (elem.version ? elem.version : "--"));
      let version = 0;
      tagList.forEach(tag => {
        let actualVersion = tag.split(".")[0];
        if (version < actualVersion) version = Number(actualVersion) + 1;
      });
      if (version === 0) return "1.00";
      return `${version}.00`;
    },
    async setDatasheet(newUrl) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      const version = this.calculateVersionTag(this.equipmentProfile.datasheet);
      let newDatasheet = {
        createdBy: this.user.email,
        createdDate: new Date(),
        url: newUrl,
        version
      };
      if (!this.equipmentProfile.datasheet) {
        this.equipmentProfile.datasheet = [newDatasheet];
      } else {
        this.equipmentProfile.datasheet = [
          ...this.equipmentProfile.datasheet,
          newDatasheet
        ];
      }
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: this.equipmentProfile
      };
      await this.$store.dispatch("updateDocument", payload);
      loading.close();
      this.$dialog.notify.info("Document updated successfully", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-email"
      });
    },
    async removeDatasheet(item) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      this.equipmentProfile.datasheet = this.equipmentProfile.datasheet.filter(
        datasheet => datasheet.url !== item.url
      );
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: this.equipmentProfile
      };
      await this.$store.dispatch("updateDocument", payload);

      loading.close();
      this.$dialog.notify.info("Document updated successfully", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-email"
      });
    },
    async setDrawings(newUrl) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      const version = this.calculateVersionTag(this.equipmentProfile.drawings);
      let newDrawings = {
        createdBy: this.user.email,
        createdDate: new Date(),
        url: newUrl,
        version
      };
      if (!this.equipmentProfile.drawings) {
        this.equipmentProfile.drawings = [newDrawings];
      } else {
        this.equipmentProfile.drawings = [
          ...this.equipmentProfile.drawings,
          newDrawings
        ];
      }
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: this.equipmentProfile
      };
      await this.$store.dispatch("updateDocument", payload);
      loading.close();
      this.$dialog.notify.info("Document updated successfully", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-email"
      });
    },
    async removeDrawings(item) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      this.equipmentProfile.drawings = this.equipmentProfile.drawings.filter(
        drawings => drawings.url !== item.url
      );
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: this.equipmentProfile
      };
      await this.$store.dispatch("updateDocument", payload);

      loading.close();
      this.$dialog.notify.info("Document updated successfully", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-email"
      });
    },
    updateMediaList: async function(item) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      if (!this.equipmentProfile.media) {
        this.equipmentProfile.media = [];
      }

      this.equipmentProfile.media.push(item);
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: this.equipmentProfile
      };
      await this.$store.dispatch("updateDocument", payload);

      loading.close();
      this.$dialog.notify.info("Document updated successfully", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-email"
      });
    },
    deleteElement: async function(item, type, name, index) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      const newMedia = this.equipmentProfile.media.filter(
        elem => elem !== item
      );
      this.$delete(this.media, index);
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: { ...this.equipmentProfile, media: newMedia }
      };

      await this.$store.dispatch("updateDocument", payload);

      await storage
        .ref(`equipments/${this.equipmentProfile.id}/${type}/${name}`)
        .delete()
        .then(() => {
          console.log(`${name} deleted`);
        });

      loading.close();
      this.$dialog.notify.info("Media element deleted", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-email"
      });
    }
  }
};
</script>

<style></style>
